module.exports = __webpack_public_path__ + "static/img/start.ac33b349.svg";